<div
	gdColumns="repeat(auto-fill, minmax(250px, 1fr))"
	gdGap="10px"
	[formGroup]="form"
>
	<mat-form-field>
		<rpshared-currency-input
			[required]="regularTimeBasis === regularTimeBasisEnum.Daily"
			autocomplete="standard-daily-rate"
			placeholder="Regular Daily Rate"
			formControlName="standardDailyRate"
		>
		</rpshared-currency-input>
		<mat-error
			*ngIf="form.get('standardDailyRate').hasError('isNotNumeric')"
		>
			Not a valid value
		</mat-error>
		<mat-error *ngIf="form.get('standardDailyRate').hasError('min')">
			Value must be above $0.00
		</mat-error>
		<mat-error *ngIf="form.get('standardDailyRate').hasError('required')">
			Required
		</mat-error>
	</mat-form-field>
	<mat-form-field>
		<rpshared-currency-input
			[required]="regularTimeBasis === regularTimeBasisEnum.Hourly"
			autocomplete="standard-hourly-rate"
			placeholder="Regular Hourly Rate"
			formControlName="standardHourlyRate"
		>
		</rpshared-currency-input>
		<mat-error
			*ngIf="form.get('standardHourlyRate').hasError('isNotNumeric')"
		>
			Not a valid value
		</mat-error>
		<mat-error *ngIf="form.get('standardHourlyRate').hasError('min')">
			Value must be above $0.00
		</mat-error>
		<mat-error *ngIf="form.get('standardHourlyRate').hasError('required')">
			Required
		</mat-error>
	</mat-form-field>
	<mat-form-field>
		<rpshared-currency-input
			autocomplete="overtime-hourly-rate"
			placeholder="Overtime Hourly Rate"
			formControlName="overtimeHourlyRate"
		>
		</rpshared-currency-input>
		<mat-error
			*ngIf="form.get('overtimeHourlyRate').hasError('isNotNumeric')"
		>
			Not a valid value
		</mat-error>
		<mat-error *ngIf="form.get('overtimeHourlyRate').hasError('min')">
			Value must be above $0.00
		</mat-error>
	</mat-form-field>
	<mat-form-field>
		<rpshared-currency-input
			autocomplete="off"
			placeholder="Nights Daily Rate"
			formControlName="nightDailyRate"
		>
		</rpshared-currency-input>
		<mat-error *ngIf="form.get('nightDailyRate').hasError('isNotNumeric')">
			Not a valid value
		</mat-error>
		<mat-error *ngIf="form.get('nightDailyRate').hasError('min')">
			Value must be above $0.00
		</mat-error>
	</mat-form-field>
	<mat-form-field>
		<rpshared-currency-input
			autocomplete="off"
			placeholder="Weekends Daily Rate"
			formControlName="weekendDailyRate"
		>
		</rpshared-currency-input>
		<mat-error
			*ngIf="form.get('weekendDailyRate').hasError('isNotNumeric')"
		>
			Not a valid value
		</mat-error>
		<mat-error *ngIf="form.get('weekendDailyRate').hasError('min')">
			Value must be above $0.00
		</mat-error>
	</mat-form-field>
	<mat-form-field>
		<rpshared-currency-input
			autocomplete="off"
			placeholder="Holidays Daily Rate"
			formControlName="holidayDailyRate"
		>
		</rpshared-currency-input>
		<mat-error
			*ngIf="form.get('holidayDailyRate').hasError('isNotNumeric')"
		>
			Not a valid value
		</mat-error>
		<mat-error *ngIf="form.get('holidayDailyRate').hasError('min')">
			Value must be above $0.00
		</mat-error>
	</mat-form-field>
	<mat-form-field>
		<rpshared-currency-input
			autocomplete="off"
			placeholder="Nights OT Hourly Rate"
			formControlName="nightOvertimeHourlyRate"
		>
		</rpshared-currency-input>
		<mat-error
			*ngIf="form.get('nightOvertimeHourlyRate').hasError('isNotNumeric')"
		>
			Not a valid value
		</mat-error>
		<mat-error *ngIf="form.get('nightOvertimeHourlyRate').hasError('min')">
			Value must be above $0.00
		</mat-error>
	</mat-form-field>
	<mat-form-field>
		<rpshared-currency-input
			autocomplete="off"
			placeholder="Weekends OT Hourly Rate"
			formControlName="weekendOvertimeHourlyRate"
		>
		</rpshared-currency-input>
		<mat-error
			*ngIf="
				form.get('weekendOvertimeHourlyRate').hasError('isNotNumeric')
			"
		>
			Not a valid value
		</mat-error>
		<mat-error
			*ngIf="form.get('weekendOvertimeHourlyRate').hasError('min')"
		>
			Value must be above $0.00
		</mat-error>
	</mat-form-field>
	<mat-form-field>
		<rpshared-currency-input
			autocomplete="off"
			placeholder="Holidays OT Hourly Rate"
			formControlName="holidayOvertimeHourlyRate"
		>
		</rpshared-currency-input>
		<mat-error
			*ngIf="
				form.get('holidayOvertimeHourlyRate').hasError('isNotNumeric')
			"
		>
			Not a valid value
		</mat-error>
		<mat-error
			*ngIf="form.get('holidayOvertimeHourlyRate').hasError('min')"
		>
			Value must be above $0.00
		</mat-error>
	</mat-form-field>
	<mat-form-field *ngIf="form.get('serviceType')?.value?.id === utilityServiceType">
		<rpshared-currency-input
			autocomplete="off"
			placeholder="Stand-Down Day Rate"
			formControlName="standDownDayRate"
		>
		</rpshared-currency-input>
		<mat-error
			*ngIf="
				form.get('standDownDayRate').hasError('isNotNumeric')
			"
		>
			Not a valid value
		</mat-error>
		<mat-error
			*ngIf="form.get('standDownDayRate').hasError('min')"
		>
			Value must be above $0.00
		</mat-error>
	</mat-form-field>
	<mat-form-field>
		<rpshared-currency-input
			autocomplete="per-diem"
			placeholder="Per Diem Surcharge"
			formControlName="perDiem"
		>
		</rpshared-currency-input>
		<mat-error *ngIf="form.get('perDiem').hasError('isNotNumeric')">
			Not a valid value
		</mat-error>
		<mat-error *ngIf="form.get('perDiem').hasError('min')">
			Value must be above $0.00
		</mat-error>
	</mat-form-field>
	<mat-form-field>
		<rpshared-currency-input
			autocomplete="initial-mobilization"
			placeholder="Mobilization Fee"
			formControlName="initialMobilization"
		>
		</rpshared-currency-input>
		<mat-error
			*ngIf="form.get('initialMobilization').hasError('isNotNumeric')"
		>
			Not a valid value
		</mat-error>
		<mat-error *ngIf="form.get('initialMobilization').hasError('min')">
			Value must be above $0.00
		</mat-error>
	</mat-form-field>
	<mat-form-field>
		<rpshared-currency-input
			autocomplete="remobilization-fee"
			placeholder="Remobilization Fee"
			formControlName="remobilizationFee"
		>
		</rpshared-currency-input>
		<mat-error
			*ngIf="form.get('remobilizationFee').hasError('isNotNumeric')"
		>
			Not a valid value
		</mat-error>
		<mat-error *ngIf="form.get('remobilizationFee').hasError('min')">
			Value must be above $0.00
		</mat-error>
	</mat-form-field>
	<mat-form-field>
		<rpshared-currency-input
			autocomplete="demobilization-fee"
			placeholder="Demobilization Fee"
			formControlName="demobilization"
		>
		</rpshared-currency-input>
		<mat-error *ngIf="form.get('demobilization').hasError('isNotNumeric')">
			Not a valid value
		</mat-error>
		<mat-error *ngIf="form.get('demobilization').hasError('min')">
			Value must be above $0.00
		</mat-error>
	</mat-form-field>
	<mat-form-field>
		<rpshared-currency-input
			autocomplete="processing-and-handling-fee"
			placeholder="Processing and Handling Fee"
			formControlName="processingAndHandlingFee"
		>
		</rpshared-currency-input>
		<mat-error
			*ngIf="
				form.get('processingAndHandlingFee').hasError('isNotNumeric')
			"
		>
			Not a valid value
		</mat-error>
		<mat-error *ngIf="form.get('processingAndHandlingFee').hasError('min')">
			Value must be above $0.00
		</mat-error>
	</mat-form-field>

	<mat-form-field>
		<rpshared-currency-input
			autocomplete="certified-payroll-fee"
			placeholder="Certified Payroll Fee"
			formControlName="certifiedPayrollFee"
			[required]="isRequiredPayrollFee$ | async"
		>
		</rpshared-currency-input>
		<mat-error
			*ngIf="form.get('certifiedPayrollFee').hasError('isNotNumeric')"
		>
			Not a valid value
		</mat-error>
		<mat-error *ngIf="form.get('certifiedPayrollFee').hasError('min')">
			Value must be above $0.00
		</mat-error>
	</mat-form-field>
	<mat-form-field>
		<rpshared-currency-input
			autocomplete="daily-mileage-fee"
			placeholder="Daily Mileage Fee"
			formControlName="dailyMileageFee"
		>
		</rpshared-currency-input>
		<mat-error *ngIf="form.get('dailyMileageFee').hasError('isNotNumeric')">
			Not a valid value
		</mat-error>
		<mat-error *ngIf="form.get('dailyMileageFee').hasError('min')">
			Value must be above $0.00
		</mat-error>
	</mat-form-field>
	<mat-slide-toggle
		formControlName="billActualMileage"
		labelPosition="before"
		class="custom-slider"
		>Bill actual mileage
	</mat-slide-toggle>
	<mat-slide-toggle
		formControlName="isProcessingFeeMonthly"
		labelPosition="before"
		class="custom-slider"
		>Processing Fee Monthly
	</mat-slide-toggle>
	<mat-slide-toggle
		formControlName="isPayrollFeeWeekly"
		labelPosition="before"
		class="custom-slider"
		>Payroll Fee Weekly
	</mat-slide-toggle>
	<mat-form-field>
		<rpshared-currency-input
			autocomplete="expedited-service-fee"
			placeholder="Expedited Service Fee"
			formControlName="expeditedServiceFee"
		>
		</rpshared-currency-input>
		<mat-error
			*ngIf="form.get('expeditedServiceFee').hasError('isNotNumeric')"
		>
			Not a valid value
		</mat-error>
		<mat-error *ngIf="form.get('expeditedServiceFee').hasError('min')">
			Value must be above $0.00
		</mat-error>
	</mat-form-field>
	<mat-form-field>
		<input
			required
			matInput
			autocomplete="standard-day-length-hours"
			placeholder="Day Length In Hours"
			formControlName="standardDayLengthHours"
			max="24"
			min="1"
			type="number"
		/>
		<mat-error *ngIf="form.get('standardDayLengthHours').hasError('min')">
			Value must be above 0 hours
		</mat-error>
		<mat-error *ngIf="form.get('standardDayLengthHours').hasError('max')">
			Value must be below 24 hours
		</mat-error>
		<mat-error *ngIf="form.get('standardDayLengthHours').hasError('required')">
			Required
		</mat-error>
	</mat-form-field>
	<mat-form-field>
		<input
			matInput
			autocomplete="weekly-overtime-threshold"
			placeholder="Weekly Overtime Threshold"
			formControlName="weeklyOvertimeThreshold"
			min="0"
			type="number"
		/>
		<mat-error *ngIf="form.get('weeklyOvertimeThreshold').hasError('min')">
			Value must be above 0 hours
		</mat-error>
		<mat-error *ngIf="form.get('weeklyOvertimeThreshold').hasError('max')">
			Value must be below 168 hours
		</mat-error>
		<mat-error
			*ngIf="form.get('weeklyOvertimeThreshold').hasError('required')"
		>
			Required
		</mat-error>
	</mat-form-field>
	<rpshared-service-type
		formControlName="serviceType"
	></rpshared-service-type>
	<mat-form-field>
		<rpshared-currency-input 
			autocomplete="railroad-administration-fee" 
			placeholder="Railroad Administration Fee"
			formControlName="railroadAdministrationFee">
		</rpshared-currency-input>
		<mat-error *ngIf="form.get('railroadAdministrationFee').hasError('isNotNumeric')">
			Not a valid value
		</mat-error>
		<mat-error *ngIf="form.get('railroadAdministrationFee').hasError('min')">
			Value must be above $0.00
		</mat-error>
	</mat-form-field>
	<mat-form-field gdColumn="1 / -1">
		<mat-label>Notes</mat-label>
		<textarea
			matInput
			cdkTextareaAutosize
			formControlName="notes"
			#autosize="cdkTextareaAutosize"
			cdkAutosizeMinRows="2"
			cdkAutosizeMaxRows="5"
		>
		</textarea>
	</mat-form-field>
</div>
